"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _system = require("@mui/system");
var _Icon = _interopRequireDefault(require("@mui/material/Icon"));
var _webfontloader = _interopRequireDefault(require("webfontloader"));
var _Text = _interopRequireDefault(require("../Text"));
var _theme = require("../../theme");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 *
 * @param {*} str
 * @returns
 */
var camelToSnakeCase = function camelToSnakeCase(str) {
  return str.replace(/[A-Z]/g, function (letter) {
    return "_".concat(letter.toLowerCase());
  });
};

/**
 *
 * @param {*} param0
 */
var HorizonalTile = function HorizonalTile(_ref) {
  var onClick = _ref.onClick,
    title = _ref.title,
    description = _ref.description,
    icon = _ref.icon,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    disabled = _ref.disabled,
    classes = _ref.classes,
    customStyle = _ref.customStyle,
    id = _ref.id,
    testid = _ref.testid;
  (0, _react.useEffect)(function () {
    _webfontloader["default"].load({
      google: {
        families: ['Material Icons']
      }
    });
  }, []);

  /**
   * 
   * @returns 
   */
  function setDisabled() {
    if (disabled) {
      var disabledStyle = {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none'
        }
      };
      return disabledStyle;
    }
    return null;
  }
  var ContainerDiv = (0, _system.styled)('div')(function () {
    return _objectSpread(_objectSpread({
      boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.15)',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: "24px 32px",
      cursor: 'pointer',
      position: 'relative',
      '&:hover': {
        boxShadow: '0px 12px 40px rgba(0, 0, 0, 0.15)'
      },
      zIndex: 2,
      background: isSelected ? _theme.colors.lightBlue : _theme.colors.surface,
      border: isSelected ? "5px ".concat(_theme.colors.gradientBlue, " solid") : 'none'
    }, setDisabled()), customStyle);
  });
  var styles = {
    // TODO: Remove style below if unused
    // disabledOverlay: {
    //     display: 'flex',
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //     position: 'absolute',
    //     width: '100%',
    //     height: '100%',
    //     background: 'rgba(232, 232, 232, 0.7)'
    // },
    iconContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 0.5
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      flex: 5,
      padding: '0 20px',
      width: '100%'
    },
    icon: {
      color: icon.color || '#000',
      fontSize: 30
    }
  };
  return /*#__PURE__*/_react["default"].createElement(ContainerDiv, {
    id: id || testid,
    onClick: disabled || !onClick ? null : onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'start',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.iconContainer
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    style: styles.icon
  }, camelToSnakeCase(icon.name))), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.textContainer
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true
    // Todo: tile color
    ,
    color: isSelected ? _theme.colors.darkBlue : _theme.colors.darkGrey,
    display: "block",
    align: "left"
  }, title), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    light: true,
    display: "block",
    align: "left",
    margin: "10px 0 0 0",
    color: isSelected ? _theme.colors.darkBlue : _theme.colors.darkGrey,
    customStyle: {
      width: "100%",
      wordBreak: "break-word"
    }
  }, description))));
};
var _default = exports["default"] = HorizonalTile;